import Db from '@/services/Db';

export default {
  getTables() {
    return Db().get('tables');
  },
  getFeatureQuery(tableId, country, showFixed, cToken) {
    let config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    let body;
    if (showFixed) {
      body = {
        '$and': [{
          'properties.country': {
            '$eq': country
          }
        }, {
          '$or': [{
            'properties.fixed': {
              '$exists': false
            }
          }, {
            'properties.fixed': {
              '$eq': 0
            }
          }]
        }]
      };
    } else {
      body = {
        'properties.country': {
          '$eq': country
        }
      };
    }
    if (cToken) {
      return Db().post('table/' + tableId + '/features?continuation_token=' + cToken, JSON.stringify(body), config);
    } else {
      return Db().post('table/' + tableId + '/features', body, config);
    }
  },
  saveFeature(tableId, id, version, payload) {
    let config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    };
    return Db().put('table/' + tableId + '/feature/' + id, JSON.stringify(payload), config);
  }
};
